import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  initialTeamChatState,
  TeamChatMessage,
} from '@/redux/initialState/teamChat'

const teamChatWebsocketSlice = createSlice({
  name: 'teamChatWebsocket',
  initialState: initialTeamChatState,
  reducers: {
    setConnectionStatus(state, action: PayloadAction<boolean>) {
      state.isConnected = action.payload
    },
    setWebSocketError(state, action: PayloadAction<string | null>) {
      state.error = action.payload
    },
    updateTeamChatMessage(state, action: PayloadAction<TeamChatMessage>) {
      const normalizedId = String(action.payload.id)
      const messageExists = state.messages.some(
        (existingMsg) => String(existingMsg.id) === normalizedId
      )

      if (!messageExists) {
        state.messages.push({
          ...action.payload,
          id: normalizedId,
        })
      }
    },

    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    handleTeamChatMessagesLoaded(
      state,
      action: PayloadAction<{
        messages: TeamChatMessage[]
        pagination: {
          current_page: number
          total_pages: number
          has_next: boolean
          has_previous: boolean
          total_messages: number
        }
      }>
    ) {
      const { messages, pagination } = action.payload

      const normalizedMessages = messages.map((msg) => ({
        ...msg,
        id: String(msg.id),
      }))

      const newMessages = normalizedMessages.filter(
        (newMsg) =>
          !state.messages.some(
            (existingMsg) => String(existingMsg.id) === String(newMsg.id)
          )
      )

      state.messages = [...newMessages, ...state.messages]
      state.pagination = pagination
      state.loadingMoreMessages = false
    },

    setLoadingMoreMessages(state, action: PayloadAction<boolean>) {
      state.loadingMoreMessages = action.payload
    },
    clearMessages(state) {
      state.messages = []
      state.pagination = null
      state.loadingMoreMessages = false
      state.unreadCount = 0
    },
    incrementTeamUnread(state) {
      state.unreadCount += 1
    },
    clearTeamUnread(state) {
      state.unreadCount = 0
    },
  },
})

export const {
  setConnectionStatus,
  setWebSocketError,
  setIsLoading,
  updateTeamChatMessage,
  handleTeamChatMessagesLoaded,
  setLoadingMoreMessages,
  clearMessages,
  incrementTeamUnread,
  clearTeamUnread,
} = teamChatWebsocketSlice.actions

export default teamChatWebsocketSlice.reducer
